import * as React from 'react';
import AnalyticsUsersPage from '../../../components/pages/my-account/analytics/users/AnalyticsUsersPage';

export default function MyAccountAnalyticsUsersPage() {
  return <AnalyticsUsersPage />;
}
